export enum PROCESSING_METHOD {
  PLATFORM = 'PLATFORM',
  MANUAL = 'MANUAL',
}
